import { templates, type SkinPageConfig, ToastProvider } from '@nosinovacao/nosid-mfe-common';

export function ThemedToast({ children }: Readonly<{ children?: React.ReactNode }>) {
  return templates.getSkinSelector(skinConfig(children));
}

const skinConfig = (children: React.ReactNode): SkinPageConfig => {
  return {
    skins: [
      {
        selector: 'isWooTvTemplate',
        component: (
          <ToastProvider skin="woo-dark" className="left-0 top-0 z-[100] h-screen w-screen">
            {children}
          </ToastProvider>
        ),
      },
      {
        selector: 'isWooTemplate',
        component: (
          <ToastProvider skin="woo" className="left-0 top-0 z-[100] h-screen w-screen">
            {children}
          </ToastProvider>
        ),
      },
    ],
    defaultValue: (
      <ToastProvider skin="light" className="left-0 top-0 z-[100] h-screen w-screen">
        {children}
      </ToastProvider>
    ),
  };
};
